import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
  signal,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { IState } from '@cde-fe-app/app/shared/state';
import '@farmnet/survey-component';
import * as OrganisationsState from '@cde-fe-app/app/shared/state/organisations';
import { environment } from '@cde-fe-app/environments/environment';

@Component({
  selector: 'app-survey-wrapper',
  templateUrl: './survey-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
class SurveyWrapperComponent implements OnInit, OnDestroy {
  protected readonly store = inject<Store<IState>>(Store<IState>);
  protected readonly embeddedAnchorPointId = 'notifications-side-panel-survey-anchor';
  protected readonly iconAnchorPointId = 'notification-menu-button-survey-anchor';
  protected readonly basePath = environment.farmConnectBaseUrl.slice(0, -1);
  protected readonly currentOrganisation = this.store.select(OrganisationsState.getCurrentOrganisation);

  protected userLanguage = signal<string>('');
  protected userCountry = signal<string>('');
  protected userId = signal<string>('');
  protected accessToken = signal<string>('');
  protected hash = signal(this.generateSurveyHash());

  private subscriptions = new Subscription();

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.currentOrganisation.subscribe(org => {
        if (org) {
          this.regenerateSurveyHash();
        }
      })
    );

    this.subscriptions.add(
      this.store
        .select(state => state.auth)
        .pipe(filter(auth => !!auth))
        .subscribe(auth => {
          if (auth.token) {
            this.accessToken.set(auth.token);
          }

          const meta = auth.user?.user_metadata as
            { country?: string; language?: string; externalUserId?: string } | undefined;

          const country = meta?.country ?? 'GB';
          const language = meta?.language ?? 'en';
          const userId = auth.user?.sub ?? '';

          this.userCountry.set(country);
          this.userLanguage.set(language);
          this.userId.set(userId);
        })
    );
  }

  private generateSurveyHash(): string {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  private regenerateSurveyHash(): void {
    this.hash.set(this.generateSurveyHash());
  }
}

export default SurveyWrapperComponent;
